import { Place } from "@mui/icons-material";
import { Box, SxProps, Theme, Typography } from "@mui/material";
import { ThemeLabel } from "./ThemeLabel";
import { Proposition } from "../../utils/types";

type Props = {
  title: string;
  sx?: SxProps<Theme>;
  createdBy:string;
  id: string;
  date: string;
} & Pick<Proposition, "location" | "theme">;

export function PropositionCardHeader({
  title,
  location,
  theme,
  createdBy,
  sx,
  id,
  date,
}: Props) {
  return (
    <Box
      component="section"
      sx={[
        {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "4px",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Typography
        fontWeight="bold"
        sx={{
          color: "#171721",
          textTransform: "none",
          paddingLeft: 0,
        }}
        component="h1"
      >
        {title}
      </Typography>
      <Typography
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#535676",
          marginLeft: "-4px",
        }}
      >
        <Place fontSize="small" style={{ color: "#535676" }} />
        {location?.name ?? "Local desconhecido"}
      </Typography>
      {theme && <ThemeLabel theme={theme} />}
      {createdBy}
      <span style={{ marginRight: "auto" }}>{date}</span>{" "}
      <span style={{ marginLeft: "auto" }}>{`id: ${id}`}</span>
    </Box>
  );
}
